interface SidebarGroupProps {
  label: string;
  isExpanded: boolean;
  children: React.ReactNode;
}

const SidebarGroup = ({ label, isExpanded, children }: SidebarGroupProps) => (
  <div className="flex flex-col mt-3 gap-1">
    {isExpanded ? (
      <p className="text-ui-text-muted text-xs uppercase truncate">{label}</p>
    ) : (
      <span aria-hidden="true" className="h-px w-8 bg-brand-secondary-contrast/15 mx-auto my-2" />
    )}
    {children}
  </div>
);

export default SidebarGroup;
